import { RootState } from "../store/store"

export const selectStandardTimeout = (state: RootState): number | undefined => {
    return state.config.clientConfiguration?.network?.timeouts?.standardMillis
}
